// import { useEffect, useState } from "react";
// import Inputs from "../../components/InputsContainer";
import InputsContainer from "../InputsContainer/InputsContainer";
// import useFormStore from "../../store/formData";

const TabInput = (props) => {
  return (
    <div className="flex flex-col items-start gap-2 w-full">
      <span className="text-sm">{props.name}</span>
      <div
        className={`w-full h-[38px] rounded-full flex items-center cursor-pointer relative overflow-hidden bg-[#DBDBDB]`}
      >
        <div
          className={`h-full rounded-full bg-main-color-1 absolute top-0 z-[2] transition-all duration-150`}
          style={{
            width: `${Math.floor((1 / props.options.length) * 100)}%`,
            right: `${props.checked === 0 ? "0" : `${Math.floor((props.checked / props.options.length) * 100)}`}%`,
          }}
        ></div>
        <div className="flex w-full h-full items-center relative z-[3]">
          {props.options?.map((item, index) => (
            <span
              className={`h-full flex justify-center items-center transition-colors duration-150 ${props.checked === index ? "text-white-1" : "text-dark-400"}`}
              style={{
                width: `${Math.floor((1 / props.options.length) * 100)}%`,
              }}
              onClick={() => {
                props.tabClickHandler(index, item.id);
              }}
            >
              {item.name}
            </span>
          ))}
        </div>
      </div>
      {props.attributes &&
        props.attributes.map((item) => <InputsContainer data={item} />)}
    </div>
  );
};

export default TabInput;
